import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { throttle, noop, constant } from 'lodash';
import React from 'react';
import styles from './looped-slider.scss';
import { focus } from '../../widget/utils/accessibility-focus';
const EASED_TRANSITION = 'transform 0.65s ease-in-out';
const LINEAR_TRANSITION = 'transform 0.4s linear';
const getAbsDifference = (a, b) => Math.abs(Math.abs(a) - Math.abs(b));
export class LoopedSlider extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "contentRef", void 0);
    _defineProperty(this, "containerRef", void 0);
    _defineProperty(this, "accumulatedNextIndex", void 0);
    _defineProperty(this, "slideToPrev", () => {
      this.slideInDirection(-1);
    });
    _defineProperty(this, "slideToNext", () => {
      this.slideInDirection(1);
    });
    _defineProperty(this, "_doSlide", (nextIndex, index, directionDelta) => {
      const accelerationPerFrame = getAbsDifference(this.accumulatedNextIndex, index);
      this.setState({
        index: nextIndex,
        loopIndex: this.getLoopIndex(directionDelta > 0 ? nextIndex : index)
      }, () => {
        this.setTransition(accelerationPerFrame === 1 ? EASED_TRANSITION : LINEAR_TRANSITION);
        this.accumulatedNextIndex = 0;
      });
    });
    _defineProperty(this, "doSlideThrottled", throttle(this._doSlide, 400));
    _defineProperty(this, "normalizeIndexes", event => {
      if (event.target !== this.contentRef) {
        return;
      }
      const {
        index,
        loopIndex
      } = this.state;
      const startingLoopIndex = this.getLoopIndex(0);
      this.setTransition('none');
      this.setState({
        index: index - loopIndex + startingLoopIndex,
        loopIndex: startingLoopIndex
      }, () => {
        focus(this.containerRef);
      });
    });
    this.containerRef = null;
    this.contentRef = null;
    this.accumulatedNextIndex = 0;
    this.state = {
      loopIndex: this.getLoopIndex(0),
      // index of N items which represent loop sequence
      index: 0 // index of first visible item
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      index
    } = this.state;
    this.setState({
      loopIndex: this.getLoopIndex(index, nextProps),
      index
    });
  }
  getItemsCount(props) {
    if (props === void 0) {
      props = this.props;
    }
    return props.children.length;
  }
  getItemsPerScreenCount() {
    const {
      width,
      itemWidth
    } = this.props;
    return Math.floor(width / itemWidth);
  }
  getClonesCount(props) {
    if (props === void 0) {
      props = this.props;
    }
    const {
      width,
      itemWidth
    } = props;
    const count = width / itemWidth;
    return count > 1 ? count : 2;
  }
  _attachKeyToItem(item, keyPrefix) {
    return /*#__PURE__*/React.cloneElement(item, {
      key: keyPrefix + "-" + item.key
    });
  }
  getItems() {
    const {
      children
    } = this.props;
    const {
      index
    } = this.state;
    const clonesCount = this.getClonesCount();
    const itemsPerScreenCount = this.getItemsPerScreenCount();
    const clonedFirstItems = children.slice(0, clonesCount);
    const clonedLastItems = children.slice(-clonesCount);
    const items = [...clonedLastItems.map(item => this._attachKeyToItem(item, 'last')), ...children, ...clonedFirstItems.map(item => this._attachKeyToItem(item, 'first'))];
    const leftVisibleItemIndex = index + clonesCount;
    const bounds = [leftVisibleItemIndex, leftVisibleItemIndex + itemsPerScreenCount];
    const inBounds = itemIndex => itemIndex >= bounds[0] && itemIndex < bounds[1];
    return items.map((item, itemIndex) => /*#__PURE__*/React.cloneElement(item, {
      isAccessible: inBounds(itemIndex)
    }));
  }
  slideInDirection(directionDelta) {
    const {
      index
    } = this.state;
    const nextIndex = index + directionDelta;
    this.accumulatedNextIndex += nextIndex;
    this.doSlideThrottled(nextIndex, index, directionDelta);
  }
  getLoopIndex(index, props) {
    if (props === void 0) {
      props = this.props;
    }
    const itemsCount = this.getItemsCount(props);
    const clonesCount = this.getClonesCount(props);
    const itemsPerLoop = Math.floor(index / itemsCount) * itemsCount;
    return itemsPerLoop - clonesCount;
  }
  setTransition(transition) {
    if (this.contentRef) {
      this.contentRef.style.transition = transition;
    }
  }
  getContentStyle() {
    const {
      itemWidth
    } = this.props;
    const {
      index,
      loopIndex
    } = this.state;
    return {
      transform: "translate3d(" + -(index * itemWidth) + "px, 0, 0)",
      left: loopIndex * itemWidth
    };
  }
  renderPrevButton() {
    return this.props.renderPrevButton({
      onClick: this.slideToPrev
    });
  }
  renderNextButton() {
    return this.props.renderNextButton({
      onClick: this.slideToNext
    });
  }
  getContainerAriaLabel() {
    return this.props.getSlideAriaLabel({
      itemsCount: this.getItemsPerScreenCount()
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapper
    }, this.renderNextButton(), /*#__PURE__*/React.createElement("div", {
      className: styles.container,
      ref: ref => this.containerRef = ref,
      tabIndex: 0,
      "aria-label": this.getContainerAriaLabel(),
      style: {
        width: this.props.width
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.content,
      ref: ref => this.contentRef = ref,
      style: this.getContentStyle(),
      onTransitionEnd: this.normalizeIndexes
    }, this.getItems())), this.renderPrevButton());
  }
}
_defineProperty(LoopedSlider, "defaultProps", {
  getSlideAriaLabel: noop,
  renderPrevButton: constant(null),
  renderNextButton: constant(null)
});
//# sourceMappingURL=looped-slider.js.map